import HideElement from './hide-element'

export { HideElement }
